
import { mapState } from "vuex";
import VueScrollTo from "vue-scrollto";
import NuxtSSRScreenSize from 'nuxt-ssr-screen-size'
export default {
  layout: 'pdefault',
  head() {
    return {
      /* title: this.page.title */
    }
  },
  data() {
    return {
      slug: this.$route.params.slug,
      showForm: false,
      options: {
        offset: -60
      }
    }
  },
  mixins: [NuxtSSRScreenSize.NuxtSSRScreenSizeMixin],
  methods: {
    scrollToTop() {
      var cancelScroll = VueScrollTo.scrollTo('#content')
    },
    startForm() {
      this.showForm = !this.showForm
      var cancelScroll = VueScrollTo.scrollTo("#mainForm", 300, this.options)
      if (!this.showForm) {
        var cancelScroll = VueScrollTo.scrollTo("#__layout", 300, this.options)
      }
    },
  },
  mounted () {
    if (!process.server) {
			console.log(this.$vssWidth)
		}
  },
  async asyncData ({ payload }) {
    if (payload) return { page: payload }
  },
  computed: {
    ...mapState(["pages"]),
    page() {
      return this.pages.find(el => el.slug === this.slug);
    },
    transformedHTML() {
      return this.page.body.replaceAll("\\", "")
    }
  }
}
